<script>

</script>

<template>
    <div>
        <h1>QR Code</h1>
    </div>
</template>